export default __webpack_public_path__ + "locales/lo-LA/InviteDialog.json?hash=e5b00fc4099d7f57242b37dc6b01e507";